























































































import Vue from 'vue';
import {
  GetMessageDetail,
  GetMessagePage,
  GetMessageUnreadCount,
  MESSAGE_CENTER_REFRESH_EVENT,
  ReadAllMessages,
  ReadMessage,
} from '../api/message-center';

type MessageItem = {
  notificationSn: string;
  title: string;
  summary: string;
  notificationType: string;
  isRead: boolean;
  sentAt: string;
  bizType?: string;
  bizSn?: string;
  redirectType?: string;
  redirectTarget?: string;
};

type MessageDetail = MessageItem & {
  content: string;
  coverUrl?: string;
  readAt?: string;
};

export default Vue.extend({
  data() {
    return {
      loading: false,
      readAllLoading: false,
      detailVisible: false,
      pageNum: 1,
      pageSize: 10,
      total: 0,
      unreadCount: 0,
      records: [] as MessageItem[],
      currentDetail: null as MessageDetail | null,
    };
  },
  computed: {
    hasUnread(): boolean {
      return Number((this as any).unreadCount || 0) > 0;
    },
  },
  async mounted() {
    await this.fetchUnreadCount();
    await this.fetchList(1);
  },
  methods: {
    async fetchUnreadCount() {
      const res = await GetMessageUnreadCount();
      this.unreadCount = Number((res && res.unreadCount) || 0);
    },
    async fetchList(pageNum?: number) {
      const currentPageNum = pageNum || this.pageNum;
      this.loading = true;
      try {
        const res = await GetMessagePage({
          pageNum: currentPageNum,
          pageSize: this.pageSize,
        });
        this.pageNum = Number((res && res.current) || currentPageNum);
        this.pageSize = Number((res && res.size) || this.pageSize);
        this.total = Number((res && res.total) || 0);
        this.records = Array.isArray(res && res.records) ? res.records : [];
      } finally {
        this.loading = false;
      }
    },
    handleSystemNoticeClick() {
      this.fetchList(1);
    },
    handlePageChange(page: number) {
      this.fetchList(page);
    },
    async handleOpen(item: MessageItem) {
      if (!item.notificationSn) {
        return;
      }
      if (!item.isRead) {
        await ReadMessage({ notificationSn: item.notificationSn });
        item.isRead = true;
        this.unreadCount = Math.max(Number(this.unreadCount || 0) - 1, 0);
        window.dispatchEvent(new Event(MESSAGE_CENTER_REFRESH_EVENT));
      }
      this.currentDetail = await GetMessageDetail({ notificationSn: item.notificationSn });
      this.detailVisible = true;
    },
    async handleReadAll() {
      await this.$confirm('确认将全部系统通知标记为已读吗？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      });
      this.readAllLoading = true;
      try {
        await ReadAllMessages();
        this.records = this.records.map(item => ({ ...item, isRead: true }));
        this.unreadCount = 0;
        window.dispatchEvent(new Event(MESSAGE_CENTER_REFRESH_EVENT));
        this.$message.success('已全部标记为已读');
      } finally {
        this.readAllLoading = false;
      }
    },
    resetDetail() {
      this.currentDetail = null;
    },
    handleRedirect() {
      if (!this.currentDetail || !this.currentDetail.redirectTarget) {
        return;
      }
      const redirectType = this.currentDetail.redirectType || 'ROUTE';
      if (redirectType === 'URL') {
        window.open(this.currentDetail.redirectTarget, '_blank');
      } else {
        this.$router.push(this.currentDetail.redirectTarget);
      }
      this.detailVisible = false;
    },
    formatDateTime(value: string) {
      return value ? value.replace('T', ' ') : '--';
    },
  },
});
